var _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnNoproductivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-noproductivityfound",
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.012,
    height: 80,
    viewBox: "0 0 85.012 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "screen",
    d: "M1149.81,1075h-65.251a7.1,7.1,0,0,0-7.059,7.1v49.128a7.046,7.046,0,0,0,7.025,7.065h65.252a7.1,7.1,0,0,0,7.059-7.1v-49.127A7.066,7.066,0,0,0,1149.81,1075Zm-.059,48.956a4.01,4.01,0,0,1-4,4.022h-18.286a3.385,3.385,0,0,0-3.22,2.359,2.354,2.354,0,0,1-2.239,1.641h-9.679a2.354,2.354,0,0,1-2.239-1.641,3.386,3.386,0,0,0-3.22-2.359H1088.6a4.037,4.037,0,0,1-4.014-4.037v-38.147a4.009,4.009,0,0,1,4-4.021h57.156a4.037,4.037,0,0,1,4.014,4.037Z",
    transform: "translate(-1077.5 -1075)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "base",
    d: "M1191.084,1353.075H1182.4l-1.717-6.99h-22.667l-1.717,6.99h-8.69a3.066,3.066,0,0,0,0,6.131h43.48a3.066,3.066,0,0,0,0-6.131Z",
    transform: "translate(-1129.678 -1279.207)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "overlay",
    width: 9,
    height: 18,
    transform: "translate(65.92 64.783) rotate(-45)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "magnify-icn",
    transform: "translate(20.747 10.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17009",
    "data-name": "Group 17009",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20947",
    "data-name": "Path 20947",
    d: "M425.519,616.1,438.2,628.569h19.432l.47-3.3-12.562-12.214Z",
    transform: "translate(-396.278 -574.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12909",
    "data-name": "Path 12909",
    d: "M2011.983,282.68l-5.461-5.5q-4.236-4.265-8.469-8.531a2.143,2.143,0,0,1-.1-3.039c.02-.023.039-.049.049-.061l-4.88-4.914c-.329.243-.667.5-1.015.745a19.411,19.411,0,0,1-9.2,3.5,20.266,20.266,0,0,1-22.28-16.711c-.111-.637-.163-1.284-.245-1.927-.008-.063-.028-.125-.042-.187v-2.773c.061-.505.115-1.012.187-1.516a20.175,20.175,0,0,1,19.807-17.463,19.437,19.437,0,0,1,10.282,2.695,19.743,19.743,0,0,1,9.7,13.441,20.022,20.022,0,0,1-4.048,17.04c-.02.026-.04.051-.058.078a.086.086,0,0,0-.012.028l4.857,4.889a2.115,2.115,0,0,1,2.055-.562,2.3,2.3,0,0,1,1.094.679q4.985,5.021,9.974,10.04l3.977,4.007a.681.681,0,0,1,.005.885l-5.119,5.161Zm-31.443-21.942a16.08,16.08,0,1,0-15.956-16.069A16.024,16.024,0,0,0,1980.54,260.738Z",
    transform: "translate(-1960.343 -224.299)",
    fill: "#e5e5e5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12900",
    "data-name": "Path 12900",
    d: "M194.682,846.7a4.651,4.651,0,0,1,.12.746q.011,7.564.005,15.128v.652h1.257V862.7q0-4.472,0-8.944c0-.872.308-1.121,1.379-1.122q1.162,0,2.324,0c.989,0,1.322.268,1.323,1.066q0,4.472,0,8.944v.59h1.257v-.552q0-5.8,0-11.6c0-.844.316-1.1,1.336-1.106.817,0,1.633,0,2.449,0,.893,0,1.24.29,1.24,1.031q0,5.852,0,11.7v.53h1.257v-.521q0-2.479,0-4.958c0-.762.344-1.035,1.294-1.037.858,0,1.717-.006,2.575,0,.779.007,1.152.308,1.154.945.007,1.839,0,3.678,0,5.6a5.941,5.941,0,0,1,.928.012,2.109,2.109,0,0,1,.568.278c-.2.108-.387.223-.592.318a.69.69,0,0,1-.248,0q-9.7,0-19.407,0a7.311,7.311,0,0,1-.853-.1q0-8.539,0-17.078Z",
    transform: "translate(-163.097 -824.402)",
    fill: "#00aafc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNoproductivity);
export default __webpack_public_path__ + "static/media/icn-no productivity.a619ce444a959f3bd52538fc26a3d91b.svg";
export { ForwardRef as ReactComponent };